<template>
  <div class="w-full py-1">
    <transition name="slide-fade">
      <div class="vs-input--label" v-if="innerValue && (innerValue.length || Object.keys(innerValue).length)">
        <span class="hrsys-input-label">{{ inputLabel }}</span>
      </div>
    </transition>
    <div style="height: 17px"></div>
    <multiselect
      :placeholder="inputLabel"
      selectedLabel=""
      selectLabel=""
      deselectLabel=""
      @input="$emit('input', $event)"
      @search-change="$emit('search-change', $event)"
      v-bind="$attrs"
      v-model="innerValue">
    </multiselect>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'

  export default {
    inheritAttrs: true,
    components: {
      Multiselect
    },
    props: ['inputLabel', 'value'],
    data: () => ({
      innerValue: []
    }),
    watch: {
      // Handles internal model changes.
      innerValue (newVal) {
        this.$emit("input", newVal);
      },
      // Handles external model changes.
      value (newVal) {
        this.innerValue = newVal;
      }
    },
    created () {
      if (this.value) {
        this.innerValue = this.value;
      }
    }
  }
</script>

<style lang="scss">
  .multiselect * {
    @apply text-sm;
  }

  .multiselect__tags {
    @apply border-gray-400;
  }
</style>
